var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var FontWeightMap;
(function (FontWeightMap) {
    FontWeightMap["thin"] = "100";
    FontWeightMap["hairline"] = "100";
    FontWeightMap["extra light"] = "200";
    FontWeightMap["ultra light"] = "200";
    FontWeightMap["light"] = "300";
    FontWeightMap["book"] = "300";
    FontWeightMap["regular"] = "400";
    FontWeightMap["normal"] = "400";
    FontWeightMap["medium"] = "500";
    FontWeightMap["semi bold"] = "600";
    FontWeightMap["bold"] = "700";
    FontWeightMap["extra bold"] = "800";
    FontWeightMap["black"] = "900";
})(FontWeightMap || (FontWeightMap = {}));
const possibleFontExtensions = ['ttf', 'otf'];
const getFontFace = (font) => {
    var _a;
    const fontFace = new FontFace(font.font_family, `url(${font.file_url})`, {});
    fontFace.weight = (_a = font.computedWeight) !== null && _a !== void 0 ? _a : '400';
    return fontFace;
};
const replaceNonAlphanumericWithDash = (text) => text.replace(/[\W]/g, '-');
export const getDisplayFontFamilyName = (familyName) => {
    const splitFamilyName = familyName.split('.');
    const familyNameHasAppendedType = possibleFontExtensions.includes(splitFamilyName[splitFamilyName.length - 1]);
    if (familyNameHasAppendedType) {
        splitFamilyName.splice(-1);
    }
    return replaceNonAlphanumericWithDash(splitFamilyName.join('.'));
};
export const getSafeFontFamilyName = (familyName) => `Font-${replaceNonAlphanumericWithDash(familyName)}`;
export const loadFontFacesToDocument = (fonts) => __awaiter(void 0, void 0, void 0, function* () {
    const loadedFonts = [];
    yield Promise.all(fonts.map((font) => __awaiter(void 0, void 0, void 0, function* () {
        const fontFace = getFontFace(font);
        try {
            const loadedFont = yield fontFace.load();
            document.fonts.add(loadedFont);
            loadedFonts.push(font);
        }
        catch (error) {
            console.error('Font not supported:', fontFace.family);
        }
    })));
    return loadedFonts;
});
export const computeFontProperties = (font) => {
    var _a, _b;
    const fontWeight = font.font_weight !== null ? font.font_weight : 'Regular';
    const computedWeight = font.font_weight !== null ? computeFontWeight(font.font_weight) : '400';
    return {
        font_family: getSafeFontFamilyName((_a = font.font_family) !== null && _a !== void 0 ? _a : font.name),
        display_font_family: getDisplayFontFamilyName((_b = font.font_family) !== null && _b !== void 0 ? _b : font.name),
        computedWeight,
        font_weight: fontWeight,
    };
};
export const computeFontWeight = (weight) => {
    var _a;
    if (!weight) {
        return '400';
    }
    const weightKey = weight.toLowerCase();
    return (_a = FontWeightMap[weightKey]) !== null && _a !== void 0 ? _a : '400';
};
